import { BASE_PATH } from '@/consts/environmental';
const getImageSrc = (imgName: string) => {
  return `${BASE_PATH}/images/components/confetti/${imgName}`;
};
const images = [
  getImageSrc('orange1.svg'),
  getImageSrc('orange2.svg'),
  getImageSrc('orange3.svg'),
  getImageSrc('orange4.svg'),
  getImageSrc('pink1.svg'),
  getImageSrc('pink2.svg'),
  getImageSrc('pink3.svg'),
  getImageSrc('pink4.svg'),
  getImageSrc('pink5.svg'),
  getImageSrc('pink6.svg'),
  getImageSrc('pink7.svg'),
  getImageSrc('pink8.svg'),
  getImageSrc('pink9.svg'),
  getImageSrc('pink10.svg'),
  getImageSrc('pink11.svg'),
  getImageSrc('pink12.svg'),
  getImageSrc('pink13.svg'),
  getImageSrc('pink14.svg'),
  getImageSrc('purple1.svg'),
  getImageSrc('purple2.svg'),
  getImageSrc('purple3.svg'),
  getImageSrc('purple4.svg'),
  getImageSrc('purple5.svg'),
  getImageSrc('purple6.svg'),
  getImageSrc('purple7.svg'),
];

export default images;
